import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Outlet, useLocation } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { Footer, NavBar, Scroller } from '../index';
import { PageContainer } from './styles';
import SubNavBar from '../SubNavBar';
import { LinearLoader } from '../Loader';
import FaqBanner from '../FaqBanner';
import { feBaseUrl } from '../../../app/api/config';
import NavbarEnv from '../NavbarEnv';
import BackButton from '../../atoms/BackButton/BackButton';

const GlobalLayout = ({
  menuLogo,
  menuLinks,
  footer,
  subFooter,
  isLoading,
  modalIsOpen,
}) => {
  const { pathname } = useLocation();
  return (
    <>
      <Helmet>
        <title>SISFOR+ - Area privata</title>
        <link rel="canonical" href={`${feBaseUrl}${pathname}`} />
      </Helmet>
      <NavBar />
      <NavbarEnv />
      <SubNavBar menuLogo={menuLogo} menuLinks={menuLinks} />
      <BackButton />
      {isLoading && !modalIsOpen && <LinearLoader />}
      <PageContainer id="anchor">
        <Outlet />
      </PageContainer>
      <FaqBanner />
      <Scroller />
      <Footer footer={footer} subFooter={subFooter} />
    </>
  );
};

GlobalLayout.propTypes = {
  menuLogo: PropTypes.object,
  menuLinks: PropTypes.array,
  footer: PropTypes.array,
  subFooter: PropTypes.array,

  // HOC (connect, state)
  isLoading: PropTypes.bool.isRequired,
  modalIsOpen: PropTypes.bool,
};

export default connect((state) => {
  const { menuLogo, menuLinks, footer, subFooter } = state.home;
  const {
    loader: { isSpinning: isLoading },
    modal: { isOpen: modalIsOpen },
  } = state.app;
  return {
    menuLogo,
    menuLinks,
    footer,
    subFooter,
    isLoading,
    modalIsOpen,
  };
})(GlobalLayout);
